import { BaseModal, ModalResultType } from "../../modal/index";
import { Template, LazyTemplate } from "../../template/index";

export default class SyncModal extends BaseModal
{
    public template = Template.lazy('/core/modals/sync/index.html');


    constructor()
    {
        super();
    }

    public beforeRender(): PromiseLike<void>
    {
        this.data.title = this.pgettext('Title', 'Synchronization');
        this.data.message = this.pgettext('Sync', `Select full reset if you'd like to perform a hard reset for the client.`);
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {
        this.element.querySelector('button.continue').addEventListener('click', e =>
        {
            const beginCountdown = () =>
            {
                let seconds = 4;
                let counterCallback = () =>
                {
                    seconds--;
                    this.data.message = this.pgettext('Message', 'Successfully synchronized client! Continuing in {seconds}...', {seconds: `<b>${seconds}</b>`});
                }

                let counter = setInterval(counterCallback, 1000);
                counterCallback();

                setTimeout(() => 
                {
                    location.reload();
                    clearInterval(counter);
                }, seconds * 1000);
            }

            if (this.data.fullSync)
            {
                indexedDB.deleteDatabase(this.app.db.name);
                beginCountdown();
            }
            else
            {
                this.app.synchronizer.pullUpdates().then(() =>
                {
                    beginCountdown();
                }, (error) =>
                {
                    this.data.message = this.pgettext('Error', 'Synchronization failed: {error}', {error: error.message});
                });
            }

        });

        return super.afterRender();
    }

    public onCancelButtonClick(e: MouseEvent)
    {
        this.close(ModalResultType.CANCEL);
    }

    public formSubmitted(form: HTMLFormElement): PromiseLike<void>
    {
        this.app.setFormEnabled(form, false);

        return Promise.resolve();
    }
}